import { request } from "./client";
import type { HitlInboxFilters, HitlItem } from "@/types/hitl";

type HitlListResponse = {
  items?: HitlItem[];
  data?: HitlItem[];
};

function buildQuery(filters: HitlInboxFilters): string {
  const params = new URLSearchParams();
  if (filters.category && filters.category !== "all") {
    params.set("category", filters.category);
  }
  if (filters.status && filters.status !== "all") {
    params.set("status", filters.status);
  }
  if (filters.mineOnly) {
    params.set("assigned_to_me", "1");
  }
  if (filters.assigned_to) {
    params.set("assigned_to", filters.assigned_to);
  }
  if (filters.limit) {
    params.set("limit", String(filters.limit));
  }
  return params.toString();
}

export async function fetchHitlInbox(filters: HitlInboxFilters = {}): Promise<HitlItem[]> {
  const query = buildQuery(filters);
  const payload = await request<HitlListResponse>(`/hitl/inbox${query ? `?${query}` : ""}`);
  if (Array.isArray(payload?.items)) return payload!.items!;
  if (Array.isArray(payload?.data)) return payload!.data!;
  return [];
}

export async function fetchHitlItem(id: string): Promise<HitlItem | null> {
  if (!id) return null;
  const payload = await request<{ item?: HitlItem; data?: HitlItem }>(`/hitl/${encodeURIComponent(id)}`);
  if (payload?.item) return payload.item;
  if (payload?.data) return payload.data;
  return null;
}

export async function approveHitlItem(id: string, body?: Record<string, unknown>) {
  return request(`/hitl/${encodeURIComponent(id)}/approve`, { method: "POST", body: body ?? undefined });
}

export async function rejectHitlItem(id: string, reason?: string) {
  const payload = reason ? { reason } : undefined;
  return request(`/hitl/${encodeURIComponent(id)}/reject`, { method: "POST", body: payload });
}

export async function requestHitlChanges(id: string, notes: string) {
  const body = notes ? { notes } : undefined;
  return request(`/hitl/${encodeURIComponent(id)}/request-changes`, { method: "POST", body });
}

export async function assignHitlItem(id: string, userId: string | null | undefined) {
  const body =
    typeof userId === "string" && userId.trim().length
      ? { assigned_to: userId }
      : { assigned_to: null };
  return request(`/hitl/${encodeURIComponent(id)}/assign`, { method: "POST", body });
}
